module Omni.Booker {
    export class PropertyDetail {
        public HotelId: string;
        public PropertyName: string;
        public IsComingSoon: boolean;
        public ComingSoonText: string;
        public HotelLink: string;
        public RedeemFreeNights: boolean;
        public IsVillas: boolean;
        constructor() {

        }
    }

    export class TravelDates {
        public ArrivalDate: string;
        public DepartureDate: string;

        constructor() {

        }
    }
    
    export class RoomDetail {
        public RoomCount: number;
        public Rooms: Room[];
        public Accessible: boolean;
        public BedRoomCount: BedroomOption;
        public VillasView: ViewOption;

        constructor() {
            this.RoomCount = 0;
            this.Rooms = [];
            this.BedRoomCount = null;
            this.VillasView = null;
        }
    }
    export class Room {
        private static OccupancyAlertNumber: number = 5;
        public AdultCount: number;
        public ChildCount: number;
        public ChildAges: number[];
        

        constructor() {
            this.AdultCount = 0;
            this.ChildCount = 0;
            this.ChildAges = [];            
        }

        public ShowOccupancyAlert = () => {
            if (this.AdultCount + this.ChildCount >= Room.OccupancyAlertNumber) {
                return true;
            }
            return false;
        }
    }    

    export class RateCodes {
        public RateCode: string;
        public IsRedeemingFreeNights: boolean;
        public PromoCode: string;
        public GroupCode: string;
        public TravelAgentNumber: string;

        constructor() {

        }
    }

    NgModule.component("omniBooker", {
        bindings: {
            currentPropertyData: "@"
        },
        controller: class OmniBookerController {
            private currentPropertyData;    // Data set from attribute, do not modify this

            // public selectedBookingProperty;
            public findEnabled: boolean;

            //For Calendars       
            public isArrivalOpen: boolean;
            public isDepartOpen: boolean;

            // Data properties for component bindings
            public PropertyDetailData: PropertyDetail;
            public TravelDatesData: TravelDates;
            public RoomDetailData: RoomDetail;
            public RateCodesData: RateCodes;

            static $inject = ["$window", "$document", "moment", "omni.bookingapiservice", "omni.bookingservice", "$log", "$scope", "$timeout"];
            constructor(
                private $window: ng.IWindowService,
                private $document: ng.IDocumentService,
                private moment,
                private BookingApiService: IBookingApiService,
                private BookingService: IBookingService,
                private $log: ng.ILogService,
                private $scope: ng.IScope,
                private readonly $timeout: ng.ITimeoutService
            ) {
                this.addMarginOnAlert();
                $window.addEventListener("resize", () => {
                    this.addMarginOnAlert();
                });    
                
                $document.bind("keydown", (e: any) => {
                    //Keycode for ESC
                    if (e.keyCode === 27)
                    {
                        this.closeBookerEvent();
                        this.$scope.$apply();
                    }
                    else if (e.keyCode === 9){
                        this.tabBookerEvent(e);
                        this.$scope.$apply();
                    }
                });      
            }

            // ReSharper disable once InconsistentNaming - This is angular's component API
            public $onInit() {
                this.PropertyDetailData = this.BookingService.GetPropertyDetail();
                this.TravelDatesData = this.BookingService.GetTravelDates();
                this.RoomDetailData = this.BookingService.GetRoomDetails();
                this.RateCodesData = this.BookingService.GetRateCodes();

                this.isArrivalOpen = false;
                this.isDepartOpen = false;
           
                // Sync up data upon initialization of component
                this.BookingService.PutTravelDates(this.TravelDatesData);
                this.BookingService.PutRateCodes(this.RateCodesData);

                var parsedViewModel = JSON.parse(this.currentPropertyData);

                if (parsedViewModel) {
                    this.findEnabled = false;
                    this.PropertyDetailData.HotelId = parsedViewModel.PropertyId;
                    this.PropertyDetailData.PropertyName = parsedViewModel.PropertyName;
                    this.PropertyDetailData.IsComingSoon = parsedViewModel.IsComingSoon;
                    this.PropertyDetailData.ComingSoonText = parsedViewModel.ComingSoonText;
                    this.PropertyDetailData.HotelLink = parsedViewModel.HotelLink;
                    this.PropertyDetailData.RedeemFreeNights = parsedViewModel.RedeemFreeNights;
                    this.PropertyDetailData.IsVillas = parsedViewModel.IsVillasProperty;

                    this.focusArrivalDate();
                } else {
                    this.findEnabled = true;
                }

                this.$scope.$watch(() => { return this.findEnabled },
                    (newVal) => {
                        this.$log.debug("FindEnabled flipped");
                        if (newVal === false) {
                            this.focusArrivalDate();
                        }
                    });

                this.$log.debug("widget-data=", parsedViewModel);
                this.$log.debug("propertyData=", this.PropertyDetailData);
                this.$log.debug("travelData=", this.TravelDatesData);
                this.$log.debug("roomData=", this.RoomDetailData);
                this.$log.debug("rateData=", this.RateCodesData);
            }

            NavigateToHotel() {
                this.$window.location.href = this.PropertyDetailData.HotelLink;
            }

            SubmitBooking() {
                    this.BookingApiService.GetBookingLink(this.PropertyDetailData, this.TravelDatesData, this.RoomDetailData, this.RateCodesData)
                        .then((link: string) => {
                            this.$log.debug("setting booking url", link);
                            this.$window.location.href = link;
                        });
                
            }
            CollapseCalendar(mode) {
                if (mode === "SetArrival")
                {
                    this.isDepartOpen = false;
                }
                if (mode === "SetDeparture")
                {
                    this.isArrivalOpen = false;
                }
            }

            private focusArrivalDate() {
                this.$timeout(
                    () => {
                        var targetResult: any = document.querySelectorAll(".calendar-arrival .om-bk-date-range")[0];
                        if (targetResult) {
                            targetResult.focus();
                        }
                    }, 200);
            }

            private focusDepartureDate() {
                this.$timeout(
                    () => {
                        var targetResult: any = document.querySelectorAll(".calendar-departure .om-bk-date-range")[0];
                        if (targetResult) {
                            targetResult.focus();
                        }
                    }, 200);
            }

            private addMarginOnAlert() {
                if (angular.element(".security-alert").is(":visible")) {
                    var marginToApply = "0px";

                    if (screen.width > 991) {
                        marginToApply = "40px";
                    }
                    else if (screen.width <= 991 && screen.width >= 768) {
                        marginToApply = "35px";
                    }
                    else if (screen.width <= 767 && screen.width >= 550) {
                        marginToApply = "30px";
                    }
                    else if (screen.width < 550) {
                        marginToApply = "25px";
                    }

                    angular.element("omni-booker").css("margin-top", marginToApply);
                }
            }

            private closeBookerEvent()
            {
                this.BookingService.CloseBooker();
            }

            private tabBookerEvent(event: KeyboardEvent)
            {
                this.BookingService.TabBooker(event);
            }
        },
        templateUrl: 'omni-booker.html'
    });
}  